// extracted by css-extract-rspack-plugin
export default {"overflowPopover":"Xl9XNrrYtkkQeq6Y__overflowPopover___","contactDetail":"rIt9FWwyQj44rGD1__contactDetail___","blurred":"kk07M53HrssARTqW__blurred___"};